import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface UseAdvancePrivateCompanyLeadContactProps {
  contactId?: string
  onSuccess: () => void
  onError: () => void
}

const useAdvancePrivateCompanyLeadContact = ({ contactId, onSuccess, onError }: UseAdvancePrivateCompanyLeadContactProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['advancePrivateCompanyLeadContact'],
    mutationFn: async () => {
      await privateAxios.put(`/funnel/contacts/${contactId}/advance`)
    },
    onSuccess,
    onError,
  });
}

export default useAdvancePrivateCompanyLeadContact